import de from './translations/de';
import en from './translations/en';
import ru from './translations/ru';
import ua from './translations/ua';
export default {
  de,
  en,
  ru,
  ua
};
